<div mat-dialog-title *ngIf="portalName == ''">
    <student-name [firstName]="student.FirstName" [lastName]="student.LastName" [middleName]="student.MiddleName"
        [nickName]="student.NickName"></student-name>
</div>

<mat-dialog-content *ngIf="portalName == ''">
    <div *ngFor="let portal of staffPortals" style="padding-left:10px; padding-top:3px; padding-bottom:3px;">
        <a class="link" (click)="portalClick(portal.PortalName)">
            {{portal.PortalName}}
        </a>
    </div>
</mat-dialog-content>

<mat-dialog-actions *ngIf="portalName == ''">
    <div class="flex-footer-right">
        <tyl-button id="studentInfoCloseButton" image="cancel.png" label="Close" (clickEvent)="closeClick()">
        </tyl-button>
    </div>
</mat-dialog-actions>